<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    @input="dialogStateChanged"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        small
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-plus-circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">New {{ this.isContraReason ? 'Con' : 'Pro' }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Reason*"
                required
                v-model="reasonText"
                :error-messages="reasonErrors"
                :placeholder="reasonPlaceholder"
                @input="$v.reasonText.$touch()"
                @blur="$v.reasonText.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" rounded :disabled="$v.reasonText.$invalid" @click="handleConfirm">Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// vuelidate
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'OptionReasonDialog',
  mixins: [validationMixin],
  validations: {
    reasonText: { required, maxLength: maxLength(60) }
  },
  props: {
    isContraReason: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    reasonErrors () {
      const errors = []
      if (!this.$v.reasonText.$dirty) return errors
      !this.$v.reasonText.maxLength && errors.push('Reason text must be at most 60 characters long')
      !this.$v.reasonText.required && errors.push('Reason text is required.')
      return errors
    },
    reasonPlaceholder () {
      return this.isContraReason ? 'Enter your reason for being contra this option' : 'Enter your reason for being pro this option'
    }
  },
  data () {
    return {
      dialog: false,
      reasonText: null
    }
  },
  methods: {
    handleConfirm: function () {
      this.dialog = false
      const newReasonObj = {reasonText: this.reasonText, isContra: this.isContraReason}
      this.$emit('onSave', newReasonObj)
    },
    dialogStateChanged: function () {
      this.reasonText = null
      this.$v.$reset()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
